const BLOB_URL_TTL_MS = 60_000

export const prepareBlobTab = (): Window | null => {
  const openedWindow = window.open('about:blank', '_blank')

  if (openedWindow) {
    openedWindow.opener = null
  }

  return openedWindow
}

export const openBlobInNewTab = (blob: Blob, openedWindow: Window): void => {
  const url = URL.createObjectURL(blob)
  openedWindow.location.href = url
  window.setTimeout(() => URL.revokeObjectURL(url), BLOB_URL_TTL_MS)
}
